import { defineStore } from 'pinia'

export interface MediaStoreState {
    currentVideoId: string | null
    playerConfig: {
        locale: string
    }
    recentVideos: string[]
    duplicateVideos: {
        [key: string]: {
            id: string
            title: string
            similarity: number
        }[]
    }
}

export const useMediaStore = defineStore('media', {
    state: (): MediaStoreState => ({
        currentVideoId: null,
        playerConfig: {
            locale: 'ger',
        },
        recentVideos: [],
        duplicateVideos: {},
    }),

    actions: {
        playVideo(clientId: string, config = {}) {
            this.currentVideoId = clientId

            // Track recently viewed videos
            if (!this.recentVideos.includes(clientId)) {
                this.recentVideos.unshift(clientId)
                if (this.recentVideos.length > 10) {
                    this.recentVideos.pop()
                }
            }

            // Generate dummy duplicate videos if none exist for this client ID
            if (!this.duplicateVideos[clientId]) {
                this.addDummyDuplicates(clientId)
            }
        },

        addDuplicateVideos(
            clientId: string,
            duplicates: Array<{ id: string; title: string; similarity: number }>
        ) {
            this.duplicateVideos[clientId] = duplicates
        },

        // Method to generate dummy duplicates for demo purposes
        addDummyDuplicates(clientId: string) {
            // Create a hash from the clientId to get consistent "random" duplicates
            const hash = clientId.split('').reduce((a, b) => {
                a = (a << 5) - a + b.charCodeAt(0)
                return a & a
            }, 0)

            // Generate 3-5 dummy duplicates
            const count = 3 + (Math.abs(hash) % 3)
            const duplicates = []

            for (let i = 0; i < count; i++) {
                const id = `dup-${clientId}-${i}`
                const similarityBase = 0.65 + (Math.abs(hash + i) % 30) / 100

                duplicates.push({
                    id,
                    title: `Similar Video ${i + 1} (${Math.round(similarityBase * 100)}% match)`,
                    similarity: similarityBase,
                })
            }

            this.duplicateVideos[clientId] = duplicates
        },
    },

    persist: true,
})
